import * as React from "react";
const SvgArticle = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M3 3v18h18V3H3Zm11 14H7v-2h7v2Zm3-4H7v-2h10v2Zm0-4H7V7h10v2Z",
  fill: "currentColor"
}));
export default SvgArticle;